import moment from 'moment-timezone';
import locale from '@/utils/init-locale';

const momentFilter = (value, format) => {
  if (value === null || value === undefined || value === '' || format === undefined) {
    return '';
  }
  if (format === 'from') {
    return moment(value).fromNow();
  }
  return moment(value).format(format);
};

moment.locale(locale);

try {
  const supplier = JSON.parse(localStorage.getItem('supplier'));
  if (supplier) {
    moment.tz.setDefault(supplier.timezone);
  }
} catch {
  moment.tz.setDefault();
}

export { moment, momentFilter };
